var _path, _style;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLoadingSpinner = function SvgLoadingSpinner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    style: {
      animation: "spin 2s linear infinite"
    },
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M32 16a16 16 0 1 0-16 16v-3.2A12.8 12.8 0 1 1 28.8 16z"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", null, "@keyframes spin{0%{transform:rotate(0deg)}to{transform:rotate(359deg)}}")));
};
export default SvgLoadingSpinner;